import './scss/style.scss';

import './CONFIG.js';

import './components/menu/component.js';
import './components/popups/component.js';
import './components/maps/component.js';
import './components/analytics/component.js';
import data from './data.js';
import state from './state.js';

import Timeline from './components/timeline/component.js';
import SmallCards from './components/small_cards/component.js';
import BigCards from './components/big_cards/component.js';

import './components/quit.js';
import './components/inactivity.js';

const sections = [];

function _render(){

	data.sections.forEach(section_data=>{
		let cls;

		switch(section_data.type){
			case 'timeline':
				cls = Timeline;
			break;
			case 'small_cards':
				cls = SmallCards;
			break;
			case 'big_cards':
				cls = BigCards;
			break;
		}

		const section = new cls(section_data);

		section.hide();

		sections.push(section);

		document.body.appendChild(section.view);
	});
}

_render();

let current=sections[0];

current.show();

state.events.on('section',async (i)=>{
	await current.hide();
	current=sections[i];
	await current.show();
});

state.events.on('submenu',()=>{
	sections[state.section].on_submenu();
});
